export default __webpack_public_path__ + "static/media/django.5d02d729.png";